if (!customElements.get('size-guide-tabs')) {
  customElements.define(
    'size-guide-tabs',
    class SizeGuideTabs extends HTMLElement {
      connectedCallback() {
        this.buttons.forEach((button, index) => button.addEventListener('click', () => this.selectedIndex = index));

        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
        }
      }

      static get observedAttributes() {
        return ['selected-index'];
      }

      get selectedIndex() {
        return parseInt(this.getAttribute('selected-index')) || 0;
      }

      set selectedIndex(index) {
        this.setAttribute('selected-index', Math.min(Math.max(index, 0), this.buttons.length - 1).toString());
      }

      get buttons() {
        return this._buttons = this._buttons || Array.from(this.querySelectorAll('button[role="tab"]'));
      }

      get panels() {
        return this._panels = this._panels || this.buttons.map((button) => document.getElementById(button.getAttribute('aria-controls'))).filter((panel) => panel !== null);
      }

      onBlockSelect(event) {
        // Tab blocks are selected through their button, item blocks through the panel they live in.
        const panel = event.target.closest('[role="tabpanel"]');
        const index = panel ? this.panels.indexOf(panel) : this.buttons.indexOf(event.target.closest('button[role="tab"]'));

        if (index > -1) this.selectedIndex = index;
      }

      attributeChangedCallback(name, oldValue, newValue) {
        const index = parseInt(newValue);

        this.buttons.forEach((button, i) => {
          const selected = i === index;
          button.classList.toggle('button--primary', selected);
          button.classList.toggle('button--secondary', !selected);
          button.setAttribute('aria-selected', selected);
          button.disabled = selected;
        });

        this.panels.forEach((panel, i) => panel.hidden = i !== index);

        if (oldValue === newValue) return;

        this.scrollToButton(this.buttons[index]);

        const panel = this.panels[index];
        if (panel && window.Motion && !theme.config.motionReduced) {
          Motion.animate(panel, { transform: ['translateY(1rem)', 'translateY(0)'], opacity: [0, 1] }, { duration: 0.2 });
        }
      }

      scrollToButton(button) {
        const scrollArea = this.querySelector('.scroll-area');
        if (!button || !scrollArea || scrollArea.scrollWidth <= scrollArea.clientWidth) return;

        const areaRect = scrollArea.getBoundingClientRect();
        const buttonRect = button.getBoundingClientRect();

        scrollArea.scrollTo({
          left: scrollArea.scrollLeft + buttonRect.left - areaRect.left - (areaRect.width - buttonRect.width) / 2,
          behavior: theme.config.motionReduced ? 'auto' : 'smooth'
        });
      }
    }
  );
}
